import React, { createContext, useState, useContext, useEffect } from 'react';
import { getTranslation } from '../translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to German
    const savedLang = localStorage.getItem('skal9-language');
    return savedLang || 'de';
  });

  const t = getTranslation(language);

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem('skal9-language', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'de' : 'en');
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};